import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import DemoReportCard from '../components/DemoReportCard';

// This is a demo mode that bypasses Clerk for demonstration
export default function DemoMode() {
  const navigate = useNavigate();
  const [demoReports] = useState([
    {
      id: 'demo-1',
      client_name: 'Acme Restaurant Group',
      claimant_name: 'John Smith',
      status: 'completed',
      created_at: '2025-11-01T10:00:00Z',
      pdf_url: 'https://example.com/demo-report-1.pdf',
      result: {
        final_claim_amount: 507000
      },
      isDemoReport: true
    }
  ]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <div className="flex justify-between items-center">
            <p className="text-yellow-800">
              <strong>DEMO MODE:</strong> This is a preview of the dashboard with sample data.
            </p>
            <Link
              to="/sign-in"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
            >
              Exit Demo → Sign In
            </Link>
          </div>
        </div>

        {/* Sample PDF Download Banner */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-600 rounded-xl shadow-2xl p-8 mb-8 text-white">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-2">📄 View Sample Expert Report</h2>
              <p className="text-lg opacity-90">Acme Restaurant Group - Hurricane Claim ($507,000)</p>
              <p className="text-sm opacity-80 mt-2">Complete report with statistical validation, BI calculations, and methodology</p>
            </div>
            <div className="flex gap-4">
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/v1/download/sample-pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-blue-600 hover:bg-gray-100 font-bold py-4 px-6 rounded-lg shadow-lg transition-colors text-lg whitespace-nowrap flex items-center"
              >
                👁️ View PDF
              </a>
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/v1/download/sample-pdf-download`}
                className="bg-green-500 text-white hover:bg-green-600 font-bold py-4 px-6 rounded-lg shadow-lg transition-colors text-lg whitespace-nowrap flex items-center"
              >
                📥 Download
              </a>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900">ClaimSync Dashboard</h1>
        </div>

        {/* Reports List */}
        <div className="bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">Recent Reports</h2>
          <div className="space-y-3">
            {demoReports.map((report) => (
              <DemoReportCard key={report.id} report={report} />
            ))}
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-sm font-medium text-gray-600 mb-2">Sample Report</h3>
            <p className="text-3xl font-bold text-blue-600">1</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-sm font-medium text-gray-600 mb-2">Claim Amount</h3>
            <p className="text-3xl font-bold text-green-600">$507K</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-sm font-medium text-gray-600 mb-2">Report Pages</h3>
            <p className="text-3xl font-bold text-blue-600">16</p>
          </div>
        </div>
      </div>
    </div>
  );
}
